'use client';

import { c as _c } from "react/compiler-runtime";
import type { RunnerAttentionItem, RunnerAttentionTarget } from '@shared/all/helpers/runnerAttention';
import { AlertCircle, AlertTriangle, ChevronRight } from 'lucide-react';
const DOT_CLASS: Record<RunnerAttentionItem['level'], string> = {
  broken: 'bg-destructive',
  'needs-you': 'bg-amber-500'
};

/** The runner badge: red when something is broken, amber when something
 *  needs the owner, nothing when all is well. */
export const AttentionDot = t0 => {
  const $ = _c(2);
  const {
    level
  } = t0;
  let t1;
  if ($[0] !== level) {
    t1 = level ? <span data-id="runner-attention-dot" aria-hidden={true} className={`size-2 shrink-0 rounded-full ${DOT_CLASS[level]}`} /> : null;
    $[0] = level;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};

/** One line per item, each with the button that opens its fix. */
const RunnerAttentionList = t0 => {
  const $ = _c(8);
  const {
    items,
    onAction
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="px-2 pb-1 pt-0.5 text-[10.5px] font-emphasis uppercase tracking-[0.14em] text-textSecondary">Needs attention</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items || $[2] !== onAction) {
    let t3;
    if ($[4] !== onAction) {
      t3 = item => {
        const {
          action
        } = item;
        const Icon = item.level === "broken" ? AlertCircle : AlertTriangle;
        return <div key={item.id} className="flex items-start gap-2 rounded-md px-2 py-1.5"><Icon size={14} className={`mt-px shrink-0 ${item.level === "broken" ? "text-destructive" : "text-amber-500"}`} /><div className="min-w-0 flex-1"><p className="break-words text-[12px] leading-snug text-textPrimary">{item.text}</p>{action && <button type="button" onClick={() => onAction(action.target)} className="-ml-1 mt-0.5 flex items-center gap-0.5 rounded-md px-1 py-0.5 text-[11px] font-emphasis text-primary transition-colors hover:bg-primary/10">{action.label}<ChevronRight size={12} /></button>}</div></div>;
      };
      $[4] = onAction;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = items.map(t3);
    $[1] = items;
    $[2] = onAction;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div data-id="runner-attention" role="group" aria-label="Needs attention">{t1}{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default RunnerAttentionList;